import React, { useEffect } from 'react'
import { loginApi } from '../http/http';
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Auth = ({ children }) => {
    const navigate=useNavigate();

    const checkSubscription = async () => {
        try {
            const response = await axios.post(`${loginApi}`, {
                msisdn: Cookies.get("msisdn")
            });
            console.log(response, 'response---');
        }
        catch (error) {
            if (error?.response?.status == 400) {
                Cookies.remove("msisdn");
                navigate("/");
            }
            else if (error?.response?.status === 500) {
                // toast.error("Something went wrong on the server. Please try again later.");
                console.log(error, 'erro1---');

            } else {
                console.log(error, 'erro2---');
                // toast.error("Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (Cookies.get('msisdn')) {
            checkSubscription();
        }
        else {
            navigate("/");
        }
    }, []);

    return (
        <>
            {children}
        </>
    )
}

export default Auth